<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import { BaseAtom } from "components/cards/atoms";
export let container;
</script>

<style></style>

<BaseAtom _isotope="GalleryViewerBAtom" {...container}>
  <div>Gallery Viewer B Placeholder</div>
</BaseAtom>